'use strict';

// https://262.ecma-international.org/15.0/#sec-isunsignedelementtype

module.exports = function IsUnsignedElementType(type) {
	return type === 'UINT8'
		|| type === 'UINT8C'
		|| type === 'UINT16'
		|| type === 'UINT32'
		|| type === 'BIGUINT64';
};
